export enum InstrumentBrand {
  Amex = 1,
  Diners,
  Discover,
  Elo,
  Jcb,
  MasterCard,
  Maestro,
  UnionPay,
  Visa,
  PayPal,
  DirectDebit,
  Yookassa,
  DirectDebitPostFinance,
  DirectDebitLSV,
}
